/* eslint-disable consistent-return */
import { Button, Chip, Grid, IconButton } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Visibility from '@material-ui/icons/Visibility';
import {
  getInfoAttachment,
  getTrainingById,
  postAffilationFiles,
  setAffiliateAction,
} from '@webapps/business';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';
import ModalFullScreen from 'components/ModalFullScreen/ModalFullScreen';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const AffiliateCorrection = ({ close, data, refetch }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { addToast } = useToast();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [files, setFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [labelAttachment, setLabelAttachment] = useState();
  const [path, setPath] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {
    error: errorLoadingFile,
    isLoading: isLoadingAffiliationFile,
    isSuccess,
    mutateAsync: mutateAffiliationFiles,
  } = useMutation(postAffilationFiles);

  const {
    error: errorAffiliateAction,
    isLoading: isLoadingAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(setAffiliateAction);

  // const {
  //   error: errorRejectAffiliation,
  //   isLoading: isLoadingRejectAffiliation,
  //   isSuccess: isSuccessRejectAffiliation,
  //   mutate: mutateRejectAffiliation,
  // } = useMutation(setAffiliateAction);

  const handleAddFiles = (file, index) => {
    files[index] = file;
  };

  const acceptAndUploadFiles = () => {
    mutateAffiliationFiles({
      data: {
        params: data?.requiredFiles
          ?.filter(({ uploaded, valided }) => uploaded && !valided)
          .map(({ id }) => id),
        files,
      },
    });
  };

  // const rejectAffiliate = async () => {
  //   await mutateRejectAffiliation({
  //     idAffiliate: data?.id,
  //     action: 'reject',
  //   });
  // };

  // useEffect(() => {
  //   if (errorRejectAffiliation) {
  //     addToast({
  //       status: 'error',
  //       message: 'Erreur pour décliner la demande',
  //     });
  //   }
  //   if (isSuccessRejectAffiliation) {
  //     addToast({
  //       status: 'success',
  //       message: "Demande d'affiliation rejetée",
  //     });
  //     close();
  //   }
  // }, [isSuccessRejectAffiliation, errorRejectAffiliation]);

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Erreur pour accepter l'affiliation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: "Demande d'affiliation acceptée",
      });
      close();
      refetch();
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);

  useEffect(async () => {
    if (isSuccess) {
      await mutateSetAffiliateAction({
        idAffiliate: data?.id,
        action: 'accept',
      });
    }
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: 'Erreur pour envoyer les fichiers',
      });
    }
  }, [isSuccess, errorLoadingFile]);

  const {
    data: dataAttachment,
    isSuccess: isSuccessInfoAttachment,
    mutateAsync: mutateInfoAttachment,
  } = useMutation(getInfoAttachment);

  const getPathLink = (label, id) => {
    setLabelAttachment(label);
    mutateInfoAttachment({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessInfoAttachment) {
      setPath('');
      getFileURLPDF(dataAttachment?.path, setPath);
      handleClickOpen();
    }
  }, [isSuccessInfoAttachment]);

  return (
    <div className={css({ marginTop: spacing(2) })}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label="Etablissement de formation"
            value={data?.classroom?.school?.name}
          />
        </Grid>
        <Grid item xs={12}>
          <Training id={data?.classroom?.training} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label="Lieu"
            value={`${
              data?.classroom?.school?.address?.cityCode || 'Non renseigné'
            } ${data?.classroom?.school?.address?.city || ''}`}
          />
        </Grid>
        <Grid
          className={css({
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(0),
          })}
          item
          xs={12}
        >
          <Description color="primary" />
          <div className={css({ marginLeft: spacing(0), color: 'black' })}>
            Document(s) reçu(s)
          </div>
        </Grid>
        <Grid className={css({ marginTop: spacing(0) })} item xs={12}>
          {data?.additionalFiles?.length > 0 ? (
            <TableContainer fullWidth>
              <Table>
                <TableBody>
                  {data?.additionalFiles?.map(
                    ({ id, label, uploaded }, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">{label}</TableCell>
                        <TableCell align="left">
                          {uploaded && (
                            <Chip
                              classes={{
                                colorPrimary: css({
                                  background: '#dbfad8',
                                  color: 'green',
                                }),
                              }}
                              className={css({ margin: spacing(0.5) })}
                              color="primary"
                              label="Reçu"
                              size="small"
                            />
                          )}
                          {!uploaded && (
                            <Chip
                              classes={{
                                colorPrimary: css({
                                  background: '#FAE8D7',
                                  color: '#FA8100',
                                }),
                              }}
                              className={css({ margin: spacing(0.5) })}
                              color="primary"
                              label="Non reçu"
                              size="small"
                            />
                          )}
                        </TableCell>
                        {uploaded && (
                          <TableCell align="left">
                            <IconButton size="small">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => getPathLink(label, id)}
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            'Aucun document reçu'
          )}
        </Grid>
        <Grid
          className={css({
            display: 'flex',
            // alignItems: 'center',
            marginTop: spacing(0),
            flexDirection: 'column',
          })}
          item
          xs={12}
        >
          <div className={css({ display: 'flex' })}>
            <PictureAsPdfIcon color="primary" />
            <div className={css({ marginLeft: spacing(1), color: 'black' })}>
              Envoyer des documents (PDF uniquement)
            </div>
          </div>
          <div>
            {data?.requiredFiles?.length <= 0 && (
              <div>Aucun fichier demandé</div>
            )}
          </div>
          <div>
            {data?.requiredFiles?.length > 0 &&
              data?.requiredFiles
                ?.filter(({ uploaded, valided }) => uploaded && !valided)
                ?.map(({ comments, label }, index) => (
                  <div
                    key={index}
                    className={css({
                      display: 'flex',
                      marginTop: spacing(0),
                      flexDirection: 'column',
                    })}
                    item
                    xs={12}
                  >
                    <div className={css({ color: 'black' })}>{label}</div>
                    <div>
                      <span>Motif du rejet: </span>
                      <span className={css({ color: 'red' })}>{comments}</span>
                    </div>
                    <div
                      className={css({
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      })}
                    >
                      <div>
                        {files[index]
                          ? files[index]?.name
                          : 'Sélectionnez le fichier'}
                      </div>
                      <Button
                        component="label"
                        disableElevation
                        size="small"
                        variant="contained"
                      >
                        Importer
                        <input
                          accept="application/pdf"
                          hidden
                          onChange={(event) => {
                            handleAddFiles(event.target.files[0], index);
                          }}
                          type="file"
                        />
                      </Button>

                      {/* <Input
                  inputProps={{
                    accept: 'application/pdf',
                  }}
                  onChange={(event) => {
                    handleAddFiles(event.target.files[0], index);
                  }}
                  type="file"
                /> */}
                    </div>
                  </div>
                ))}
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(2),
          })}
          item
          xs
        >
          <Button
            className={css({
              borderRadius: '10.0px',
              background: '#47C509',
              color: 'white',
            })}
            disabled={
              data?.requiredFiles.filter(({ valided }) => !valided).length !==
                files.length ||
              isLoadingAffiliationFile ||
              isLoadingAffiliateAction
            }
            onClick={acceptAndUploadFiles}
            variant="contained"
          >
            Envoyer
          </Button>
          {/* <Button
            className={css({ borderRadius: '10.0px', marginLeft: spacing(1) })}
            color="primary"
            disabled={isLoadingRejectAffiliation}
            onClick={rejectAffiliate}
            
            variant="outlined"
          >
            Décliner
          </Button> */}
        </Grid>
      </Grid>
      <ModalFullScreen
        onCancel={handleClose}
        open={open}
        title={labelAttachment}
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreen>
    </div>
  );
};

AffiliateCorrection.propTypes = {
  data: PropTypes.object,
  close: PropTypes.func,
  refetch: PropTypes.func,
};

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  return (
    <TextField disabled fullWidth label="Formation" value={training?.label} />
  );
};

Training.propTypes = {
  id: PropTypes.string,
};

export default AffiliateCorrection;
